import * as PrimitiveRadixDialog from '@radix-ui/react-dialog';
import { motion } from 'framer-motion';
import { forwardRef, Ref } from 'react';
import styled from 'styled-components';
import { restrictedZIndexes } from '../../utils/restricted_z_indexes';

const StyledOverlay = styled(motion.div)`
	background-color: rgb(0 0 0 / 67%);
	position: fixed;
	inset: 0;
	/* z-index: 1; */
	/* Needs to use a high z-index to have it appear on top of other elements */
	z-index: ${restrictedZIndexes.DANGER};
`;

function SheetBackgroundOverlay(_: unknown, ref: Ref<HTMLDivElement>): JSX.Element {
	return (
		<PrimitiveRadixDialog.Overlay asChild forceMount>
			<StyledOverlay ref={ref} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} />
		</PrimitiveRadixDialog.Overlay>
	);
}

const _SheetBackgroundOverlay = forwardRef(SheetBackgroundOverlay);

export { _SheetBackgroundOverlay as SheetBackgroundOverlay };
